import React from 'react';

import { Alert } from '../common';

import type { DocumentCheck } from '../../api';

const TITLES: Record<string, string> = {
	NOT_A_STATEMENT: 'This file is not a processing statement',
	MISSING_PAGES: 'Pages are missing from this statement',
	UNREADABLE: 'Parts of this statement could not be read',
	PARTLY_READABLE: 'Part of this statement is hard to read',
	OTHER: 'There is a problem with this statement',
};

export const isNotAStatement = (check?: DocumentCheck | null): boolean =>
	check?.status === 'flagged' &&
	check.issues.some((issue) => issue.code === 'NOT_A_STATEMENT');

// No quote from a file that isn't a statement or is missing pages (ROC-75).
const QUOTE_BLOCKING_CODES = new Set(['NOT_A_STATEMENT', 'MISSING_PAGES']);

export const blocksQuote = (check?: DocumentCheck | null): boolean =>
	check?.status === 'flagged' &&
	check.issues.some((issue) => QUOTE_BLOCKING_CODES.has(issue.code));

interface DocumentCheckBannerProps {
	check?: DocumentCheck | null;
}

/** Warning for a flagged upload (ROC-72). Renders nothing when the check is ok or absent. */
const DocumentCheckBanner: React.FC<DocumentCheckBannerProps> = ({ check }) => {
	if (!check || check.status !== 'flagged' || check.issues.length === 0) {
		return null;
	}
	const variant = isNotAStatement(check) ? 'error' : 'warning';
	const title = TITLES[check.issues[0].code] ?? TITLES.OTHER;
	return (
		<Alert variant={variant} title={title}>
			<ul className="list-disc space-y-1 pl-5">
				{check.issues.map((issue, index) => (
					<li key={`${issue.code}-${index}`}>{issue.ui_message}</li>
				))}
			</ul>
		</Alert>
	);
};

export default DocumentCheckBanner;
